import React from "react";

export default function CardFeaturesTwo({
  sectionClass = "md:pb-[153px] pt-16 mb-16",
  content = {
    title: "Capabilities That Power Digital Transformation",
    description: "We handle the entire migration process smoothly, ensuring minimal downtime and stable systems while keeping your business running."
  },
  features = [
    {
      id: 1,
      title: "End-to-End Lifecycle Management",
      description: "From initial assessment to post-migration optimization."
    },
    {
      id: 2,
      title: "Continuous Replication",
      description: "Data synchronization until cutover completion."
    },
    {
      id: 3,
      title: "Planned Cutovers",
      description: "To avoid business disruption."
    },
    {
      id: 4,
      title: "Minimal Downtime",
      description: "Proven processes that keep systems running."
    }
  ],
  images = {
    background: "/assets/images/Capabilities.svg",
    main: "/assets/images/Capabilities.webp",
  }
}) {
  return (
    <section className={sectionClass}>
      <div className="w-full mx-auto theme-container px-4">
        <div className="grid grid-cols-3 gap-3 md:grid-cols-6 gap-y-10">
          <div className="col-span-3">
            <div className="max-w-[476px]">
            <h2 className="text-34 sm:text-34  md:text-48 font-semibold text-white mb-8 sm:mb-[50px]  w-full xl:w-full">
                {content.title}
              </h2>
              <p className="pt-4  text-paragraph text-sm sm:text-base">
                {content.description}
              </p>
              <ul className="flex flex-col gap-0.5 mt-6 mb-8 sm:mb-11">
                {features.map((feature, index) => (
                  <li key={feature.id} className={`flex gap-2.5 before:h-[18px] before:w-[18px] before:rounded-full before:mt-1.5 before:bg-purple tick-before before:flex before:justify-center before:items-center text-white ${index > 0 ? 'mt-4 sm:mt-6' : ''}`}>
                    <div className="flex-1">
                      <h1 className="font-semibold text-16 sm:text-18 text-white">
                        {feature.title}
                      </h1>
                      <p className="text-paragraph mt-0.5 text-sm sm:text-base">
                        {feature.description}
                      </p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="relative col-span-3 flex justify-center items-end ">
            <img
              src={images.background}
              alt=""
              className="absolute z-0"
            />
            <img
              src={images.main}
              alt=""
              className="relative z-10 moving-h2-hero-main-img"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
